// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

const logColorMapping = {
  DEBUG: 'white',
  INFO: 'green',
  WARN: 'yellow',
  ERROR: 'red',
};

const Log = ({ time, level, message }) => {
  const textColor = logColorMapping[level];
  return (
    <div style={{ color: textColor }}>
      {time} {level}: {message}
    </div>
  );
};

Log.propTypes = {
  time: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Log;
